export const useScrollLock = () => {
  const lockCount = ref(0);
  const originalOverflow = ref<string>('');

  const lockScroll = () => {
    lockCount.value++;

    if (lockCount.value === 1) {
      originalOverflow.value = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
    }
  };

  const unlockScroll = () => {
    lockCount.value = Math.max(0, lockCount.value - 1);

    if (lockCount.value === 0) {
      document.body.style.overflow = originalOverflow.value;
      document.documentElement.style.overflow = '';
    }
  };

  const forceUnlock = () => {
    lockCount.value = 0;
    document.body.style.overflow = originalOverflow.value;
    document.documentElement.style.overflow = '';
  };

  onUnmounted(() => {
    if (lockCount.value > 0) {
      forceUnlock();
    }
  });

  return {
    lockScroll,
    unlockScroll,
    forceUnlock,
    isLocked: computed(() => lockCount.value > 0),
  };
};
